import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";

const LINKS = [
  { href: "#katalog", label: "Katalog" },
  { href: "#tentang", label: "Tentang" },
  { href: "#kontak", label: "Kontak" },
];

export const Navbar = ({ company }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 0.15, duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      data-testid="navbar"
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${scrolled ? "border-b border-[#28303f] bg-[#07090e]/85 backdrop-blur-xl" : "bg-transparent"}`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 sm:px-6 lg:px-12">
        <a href="#beranda" data-testid="nav-logo-link" className="group flex items-center gap-3">
          <img src="/assets/logo.webp" alt="Logo Planet Gudang" className="h-11 w-11 rounded-full border border-[#28303f] object-cover transition-transform duration-500 group-hover:rotate-12" />
          <div className="leading-none">
            <span className="font-display block text-xl font-extrabold uppercase tracking-wide">Planet Gudang</span>
            <span className="font-mono-tech text-[9px] uppercase tracking-[0.35em] text-amber-400">Antar Galaksi</span>
          </div>
        </a>

        <nav className="hidden items-center gap-8 md:flex" data-testid="nav-links">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="font-mono-tech relative text-xs uppercase tracking-[0.25em] text-slate-300 transition-colors hover:text-amber-400 after:absolute after:-bottom-1 after:left-0 after:h-px after:w-0 after:bg-amber-400 after:transition-all after:duration-300 hover:after:w-full"
            >
              {l.label}
            </a>
          ))}
          <a
            href={`https://wa.me/${company?.wa_number || "6285714757850"}`}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-wa-button"
            className="font-mono-tech border border-[#22c55e]/60 px-5 py-2.5 text-xs uppercase tracking-[0.25em] text-[#22c55e] transition-colors duration-300 hover:bg-[#22c55e] hover:text-[#04120a]"
          >
            Hubungi
          </a>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen(!open)}
          className="text-slate-200 md:hidden"
          aria-label="Menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="border-t border-[#28303f] bg-[#07090e]/95 px-6 py-6 backdrop-blur-xl md:hidden" data-testid="nav-mobile-menu">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
              className="font-mono-tech block py-3 text-sm uppercase tracking-[0.25em] text-slate-200"
            >
              {l.label}
            </a>
          ))}
        </div>
      )}
    </motion.header>
  );
};
